import React, {
  FC, useMemo,
} from 'react';
import _ from 'lodash';
import moment from 'moment';
import history from 'app/routes/history';
import Table from 'app/components/general/Table';
import Button from 'app/components/general/Button';
import PlusIcon from 'app/images/icons/plus.svg';
import StatusBadge from 'app/components/general/StatusBadge';
import { unformatAmount, getTimeRange, parseAmount } from 'app/utils/parsers';

import { ITeamMember } from 'app/ducks/teamMembers/types';

interface IProps {
  actions: any;
  teamPaymentCollectionsById: ITeamMember[];
  teamPaymentCollectionIds: string[];
  teamId?: string;
  headerTitle?: string;
  appReady?: boolean;
  isLoading?: boolean;
  manual?: boolean;
  saveFilters?: boolean;
  initialFilterConfig?: any;
  persistentFilterConfig?: any;
  pagination?: any;
  teamCode: string;
  teamMemberCode: string;
  selectTeamPaymentCollection: (value) => void;
}

const PaymentCollectionsTable: FC<IProps> = (props: IProps = {
  manual: true,
  actions: undefined,
  teamPaymentCollectionsById: undefined,
  teamPaymentCollectionIds: undefined,
  initialFilterConfig: undefined,
  persistentFilterConfig: undefined,
  isLoading: false,
  pagination: undefined,
  selectTeamPaymentCollection: undefined,
  teamCode: undefined,
  teamMemberCode: undefined,
}) => {
  const filterOptions = [
    {
      label: 'Status',
      accessor: 'status',
      type: 'select',
      options: [
        { id: 'pending', name: 'Unpaid' },
        { id: 'paid', name: 'Paid' },
      ],
    },
    { label: 'Name', accessor: 'fullName', type: 'text' },
    { label: 'Team', accessor: 'teamName', type: 'text' },
    { label: 'Email', accessor: 'email', type: 'text' },
    { label: 'Mobile', accessor: 'mobile', type: 'text' },
  ];

  const fetchDataFromApi = ({
    sort, filter, pageNumber, pageSize,
  }): void => {
    const payload = {
      page: {
        size: pageSize,
        number: pageNumber,
      },
      sort,
      filter,
    };
    props.actions.getAllTeamPaymentCollectionsTeamMemberView(payload, true, props.teamCode, props.teamMemberCode);
  };

  const handleClick = (paymentRequestId: string, id: string): void => {
    // history.push(`/payment-requests/detail/${paymentRequestId}/collection/${id}`);
  };

  const data = useMemo(() => {
    if (_.isEmpty(props.teamPaymentCollectionsById) || props.teamPaymentCollectionIds === undefined) {
      return [];
    }
    const rows = _.reduce(
      props.teamPaymentCollectionIds,
      (obj, id) => {
        if (!_.isEmpty(props.teamPaymentCollectionsById[id])) {
          obj.push(props.teamPaymentCollectionsById[id]);
        }
        return obj;
      },
      [],
    );
    return rows;
  }, [props.teamPaymentCollectionsById, props.teamPaymentCollectionIds]);

  const renderStatus = (cellProps: {
    value: string;
  }): React.ReactNode => (
    <StatusBadge
      paymentText={cellProps.value}
    />
  );

  const renderAmount = (cellProps: {
    value: string;
  }): React.ReactNode => (
    parseAmount(cellProps.value)
  );

  const renderDate = (cellProps: {
    value: string;
  }): string => (_.isEmpty(cellProps.value) ? '' : moment(cellProps.value).format('D MMM YYYY'));

  const smallColumn = 'col col-3 col-lg-2';
  const growColumn = 'col col-4 d-flex';
  const mediumColumn = 'col col-4 col-md-3 col-lg-3 col-xl-2';

  const columns = useMemo(() => [
    {
      id: 'status',
      Header: 'Status',
      className: smallColumn,
      headerClassName: smallColumn,
      accessor: 'status',
      Cell: renderStatus,
    },
    {
      Header: 'Description',
      accessor: 'description',
      className: growColumn,
      headerClassName: growColumn,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      className: smallColumn,
      headerClassName: smallColumn,
      Cell: renderAmount,
    },
    {
      Header: 'Team Name',
      accessor: 'teamName',
      className: mediumColumn,
      headerClassName: mediumColumn,
    },
    {
      Header: 'Date Paid',
      accessor: 'purchasedAt',
      className: mediumColumn,
      headerClassName: mediumColumn,
      Cell: renderDate,
    },
  ], []);

  // const counterText = props.pagination.meta.totalCount === 1 ? '1 teamMember' : `${props.pagination.meta.totalCount || 0} team members`;

  return (
    <div>
      <Table
        data={data}
        columns={columns}
        isLoading={props.isLoading}
        headerTitle={props.headerTitle}
        objectTitle="payment collections"
        filterTitle="Payment Request Collections Data"
        // counterText={counterText}
        handleClick={handleClick}
        filterable
        saveFilters={props.saveFilters}
        manual={props.manual}
        fetchDataFromApi={fetchDataFromApi}
        filterOptions={filterOptions}
        filterConfig={props.initialFilterConfig}
        persistentFilterConfig={props.persistentFilterConfig}
        pagination={props.pagination}
        showPagination
      >
        {/* <Button btnIcon={PlusIcon} onClick={handleRequestPayment} className="btn-thinner btn-2">
          Add Person to Request
        </Button> */}
      </Table>
    </div>
  );
};

export default PaymentCollectionsTable;
